// extracted by mini-css-extract-plugin
export default {"customerDataContainer":"updateCustomer_customerDataContainer__3XvV1","customerActionContainer":"updateCustomer_customerActionContainer__WJhn4"};